import { Input as InputComponent, InputBase } from './Input';
import { InputGroup } from './InputGroup';
import { InputNumber } from './InputNumber';

export const Input = Object.assign(InputComponent, {
    Base: InputBase,
    Group: InputGroup,
    Number: InputNumber,
});

export type { InputBaseProps, InputProps } from './Input';
export type { InputGroupProps } from './InputGroup';
export type { InputNumberBaseProps, InputNumberProps, NumberFieldProps } from './InputNumber';
